import React from "react";

import CheckCircleIcon from "@uui/CheckCircle";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { Row, StackProps } from "@rui/Stack";

interface ActiveChipProps extends StackProps {
  label?: string;
  showBackground?: boolean;
}

const ActiveChip = styled<React.FC<ActiveChipProps>>(
  ({
    label = "Active",
    showBackground: _sb, // pass through to style overrides and omit from DOM element
    ...props
  }) => (
    <Row variant="center" spacing={0.5} {...props}>
      <CheckCircleIcon />
      <Typography variant="labelMed">{label}</Typography>
    </Row>
  )
)(({ theme, showBackground = true }) => ({
  padding: "1px 2px",
  borderRadius: "4px",
  backgroundColor: showBackground
    ? theme.palette.shades.meadow[50]
    : "transparent",
  color: showBackground
    ? theme.palette.shades.neutral[600]
    : theme.palette.shades.meadow[600],
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
    color: theme.palette.shades.meadow[600],
  },
}));

export default ActiveChip;
